import styled from 'styled-components';

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 20px;
    button {
        width: 8.313rem;
    }
    padding: 15px;
`;

export const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

export const AlertTitle = styled.div`
    color: ${({ theme: colors }) => colors.cyanDarkBlue};
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 19px;
`;

export const AlertDetails = styled.div`
    color: ${({ theme: colors }) => colors.cyanDarkBlue};
    font-size: 12px;
    letter-spacing: 0;
    line-height: 20px;
    white-space: pre-line;
`;

export const AlertInfoWrapper = styled(Wrapper)`
    gap: 10px;
    margin-bottom: 8px;
`;

export const CloseIcon = styled.img`
    cursor: pointer;
`;
